import { PureComponent } from 'react';
import Hotkeys from 'react-hot-keys';
import { motion } from 'framer-motion';
import { track } from '../../tracking';
import ModalDialog from '../common/ModalDialog';
import { connect, useDispatch } from 'react-redux';
import { hideDialog } from '../../store/actions/prescriptionPad';
import {
    MISC_KEYS,
    getDoc,
    getItemFromMisc,
    getSelectedClinicId,
    updateItemInMisc,
} from '../../store/idbHandler';
import { GenieSettings } from '../../api/pushGenie';
import { pushGenieToBE } from '../../store/appReduxMiddleware';
import { Button, notification } from 'antd';
import { captureError } from '../../pages/captureError';
import { EKA_EVENT, dispatch } from '../../bridge/events/dispatch';
import { Events, HPR_HFR_ONBOARDING, ON_HFR_CREATED_SUCCESSFULLY } from '../../bridge/events/types';
import { fetchMyGenie } from '../../store/actions/login';
import { ThunkDispatch } from 'redux-thunk';
import { GlobalState } from '../../store/reducers';
import { Actions } from '../../store/actions';
import { his } from '../../pages/history';
import { GO_TO_ALL_PATIENTS } from '../../routes/paths';
import pushRegisterABDMLead from '../../api/pushRegisterABDMLead';
import { getMyDbId } from '../../api/mactiveid';

type P = {
    showButtons?: boolean;
    closeMe?: () => void;
    dispatch: ThunkDispatch<GlobalState, null, Actions>;
};

class ABDMComp extends PureComponent<P> {
    onEkaEvents: EventListener = async (event: any) => {
        const { detail } = event as CustomEvent<Events>;
        track('ABDM_CREATED_EVENT_RECEIVED', { detail: JSON.stringify(detail) });
        switch (detail.type) {
            case ON_HFR_CREATED_SUCCESSFULLY:
                track('ABDM_HFR_CREATED_EVENT_RECEIVED');
                await this.enableAbha();
                // case ON_HPR_CREATED_SUCCESSFULLY:
                const docId = getDoc()?._id;
                if (!docId) {
                    return;
                }
                this.props.dispatch(
                    fetchMyGenie(undefined, undefined, () => {
                        track('ABDM_HFR_CREATED');
                        notification.success({
                            message: 'Successfully created ABDM!',
                            duration: 5,
                        });
                        his.push(GO_TO_ALL_PATIENTS(getSelectedClinicId() || ''));
                    }),
                );
                break;
        }
    };

    componentDidMount() {
        window.addEventListener(EKA_EVENT, this.onEkaEvents);
    }

    componentWillUnmount() {
        window.removeEventListener(EKA_EVENT, this.onEkaEvents);
    }

    registerNow = () => {
        pushRegisterABDMLead().catch(captureError);

        track('REGISTER_NOW_ABDM');
        dispatch({ type: HPR_HFR_ONBOARDING });
    };

    knowMore = () => {
        window.open('https://www.youtube.com/watch?v=3UV3oHKMKsk', '_blank');
        track('KNOW_MORE_ABOUT_ABDM');
    };

    ekaABDM = () => {
        window.open('https://abdm.gov.in:8081/uploads/Eka_Care_e798053387.pdf', '_blank');
        track('EKA_ABDM_CERTIFICATE');
    };

    enableAbha = async () => {
        const settings = await getItemFromMisc<GenieSettings>(
            getMyDbId() || '',
            MISC_KEYS.settings,
        );
        await updateItemInMisc(getMyDbId() || '', MISC_KEYS.settings, {
            ...settings,
            abdm: true,
        });

        try {
            await pushGenieToBE(getMyDbId() || '', ['settings']);
        } catch (err) {
            captureError(err as Error);
            notification.error({
                message: 'Error while saving',
                duration: 5,
            });
        }
    };

    render() {
        const { showButtons, closeMe } = this.props;
        return (
            <div className="px-24 py-18 space-y-20 text-14 font-400 w-704 rounded-16">
                {showButtons && closeMe && (
                    <div className="flex justify-end">
                        <svg
                            className="w-16 h-16 fill-darwin-neutral-900 cursor-pointer"
                            viewBox="0 0 12 12"
                            xmlns="http://www.w3.org/2000/svg"
                            onClick={closeMe}
                        >
                            <path d="M10.75 9.71875C11.0312 10.0312 11.0312 10.5 10.75 10.7812C10.4375 11.0938 9.96875 11.0938 9.6875 10.7812L6 7.0625L2.28125 10.7812C1.96875 11.0938 1.5 11.0938 1.21875 10.7812C0.90625 10.5 0.90625 10.0312 1.21875 9.71875L4.9375 6L1.21875 2.28125C0.90625 1.96875 0.90625 1.5 1.21875 1.21875C1.5 0.90625 1.96875 0.90625 2.25 1.21875L6 4.96875L9.71875 1.25C10 0.9375 10.4688 0.9375 10.75 1.25C11.0625 1.53125 11.0625 2 10.75 2.3125L7.03125 6L10.75 9.71875Z"></path>
                        </svg>
                    </div>
                )}

                <div className="flex justify-center space-x-40">
                    <img src="/images/abdm1.png" alt="abdm1" className="w-84 h-80" />
                    <img src="/images/abdm2.png" alt="abdm2" className="w-100 h-80" />
                </div>

                <p className="text-center text-33 font-700 space-x-8">
                    <span className="text-darwin-accent-bright-blue-800">Eka Care</span>
                    <span>is now ABDM compliant</span>
                    <span> ✅</span>
                </p>

                <p className="text-darwin-neutral-800 max-w-440 mx-auto text-center">
                    Experience enhanced healthcare capabilities with the seamless integration of Eka
                    Care and Ayushman Bharat Digital Mission (ABDM).
                </p>

                <div className="space-y-24">
                    <div className="grid grid-cols-2 gap-x-24">
                        <div className="flex space-x-16">
                            <div>
                                <div className="flex items-center justify-center bg-darwin-accent-green-800 w-36 h-36 rounded-full">
                                    <svg
                                        className="w-18 h-16 fill-white"
                                        viewBox="0 0 18 16"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path d="M0 1.99998C0 0.906235 0.875 -1.52588e-05 2 -1.52588e-05H16C17.0938 -1.52588e-05 18 0.906235 18 1.99998V11C18 12.125 17.0938 13 16 13H10.5L10.8125 14H13C13.5312 14 14 14.4687 14 15C14 15.5625 13.5312 16 13 16H5C4.4375 16 4 15.5625 4 15C4 14.4687 4.4375 14 5 14H7.15625L7.5 13H2C0.875 13 0 12.125 0 11V1.99998ZM2 1.99998V11H16V1.99998H2ZM8 3.99998C8 3.74998 8.21875 3.49998 8.5 3.49998H9.5C9.75 3.49998 10 3.74998 10 3.99998V5.49998H11.5C11.75 5.49998 12 5.74998 12 5.99998V6.99998C12 7.28123 11.75 7.49998 11.5 7.49998H10V8.99998C10 9.28123 9.75 9.49998 9.5 9.49998H8.5C8.21875 9.49998 8 9.28123 8 8.99998V7.49998H6.5C6.21875 7.49998 6 7.28123 6 6.99998V5.99998C6 5.74998 6.21875 5.49998 6.5 5.49998H8V3.99998Z" />
                                    </svg>
                                </div>
                            </div>
                            <div>
                                <p className="font-700">Digitize your front desk</p>
                                <p className="text-12 text-darwin-neutral-700">
                                    Improve patient experience with token implementation and online
                                    appointments
                                </p>
                            </div>
                        </div>
                        <div className="flex space-x-16">
                            <div>
                                <div className="flex items-center justify-center bg-darwin-accent-symptoms-blue-800 w-36 h-36 rounded-full">
                                    <svg
                                        className="w-18 h-16 fill-white"
                                        viewBox="0 0 18 16"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path d="M0 3.53123C0 2.78123 0.78125 2.28123 1.5 2.49998C4 3.15623 6.5 2.53123 9 1.90623C11.7188 1.21873 14.4375 0.499985 17.1562 1.53123C17.6562 1.71873 18 2.24998 18 2.81248V12.5C18 13.25 17.1875 13.75 16.4688 13.5312C13.9688 12.8437 11.4688 13.5 9 14.125C6.28125 14.8125 3.5625 15.5312 0.84375 14.5C0.3125 14.3125 0 13.7812 0 13.2187V3.53123ZM9 11C10.375 11 11.5 9.65623 11.5 7.99998C11.5 6.34373 10.375 4.99998 9 4.99998C7.59375 4.99998 6.5 6.34373 6.5 7.99998C6.5 9.65623 7.59375 11 9 11Z" />
                                    </svg>
                                </div>
                            </div>
                            <div>
                                <p className="font-700">Earn incentives</p>
                                <p className="text-12 text-darwin-neutral-700 mb-6">
                                    All participating entities can reimburse the expenses incurred
                                    for digitization
                                </p>
                                <a
                                    className="px-8 py-4 text-12 text-white bg-darwin-accent-bright-blue-800 rounded-4 hover:text-white"
                                    href="https://abdm.gov.in/DHIS/faqs"
                                    target="_blank"
                                    onClick={() => track('VIEW_DETAILS_INCENTIVES')}
                                >
                                    View details
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="grid grid-cols-2 gap-x-24">
                        <div className="flex space-x-16">
                            <div>
                                <div className="flex items-center justify-center bg-darwin-accent-mauve-800 w-36 h-36 rounded-full">
                                    <svg
                                        className="w-16 h-16 fill-white"
                                        viewBox="0 0 16 16"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path d="M6.5 0.999985C6.5 0.468735 6.9375 -1.52588e-05 7.5 -1.52588e-05H8.5C9.03125 -1.52588e-05 9.5 0.468735 9.5 0.999985V5.40623L13.3125 3.21873C13.7812 2.93748 14.375 3.09373 14.6562 3.59373L15.1562 4.43748C15.4375 4.93748 15.2812 5.53123 14.8125 5.81248L11 7.99998L14.8125 10.2187C15.2812 10.5 15.4375 11.0937 15.1562 11.5937L14.6562 12.4375C14.375 12.9375 13.7812 13.0937 13.3125 12.8125L9.5 10.625V15C9.5 15.5625 9.03125 16 8.5 16H7.5C6.9375 16 6.5 15.5625 6.5 15V10.625L2.6875 12.8125C2.1875 13.0937 1.59375 12.9375 1.3125 12.4375L0.8125 11.5937C0.53125 11.0937 0.6875 10.5 1.1875 10.2187L5 7.99998L1.1875 5.81248C0.6875 5.53123 0.53125 4.93748 0.8125 4.43748L1.3125 3.59373C1.59375 3.09373 2.1875 2.93748 2.6875 3.21873L6.5 5.40623V0.999985Z" />
                                    </svg>
                                </div>
                            </div>
                            <div>
                                <p className="font-700">
                                    Quality of healthcare and easy information exchange
                                </p>
                                <p className="text-12 text-darwin-neutral-700">
                                    Smooth exchange of health information among patients, healthcare
                                    professionals &amp; facilities
                                </p>
                            </div>
                        </div>
                        <div className="flex space-x-16">
                            <div>
                                <div className="flex items-center justify-center bg-darwin-accent-bright-yellow-800 w-36 h-36 rounded-full">
                                    <svg
                                        className="w-18 h-16 fill-white"
                                        viewBox="0 0 17 16"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path d="M8.71875 10.5937C8.25 11.0625 8.28125 10.9687 8.125 11.625C8 11.9375 7.78125 12.1875 7.46875 12.2812C7.03125 12.4062 7.125 12.375 7 12.4375V16L5 15L3 16V12.4375C2.84375 12.375 2.9375 12.4062 2.5 12.2812C2.1875 12.1875 1.9375 11.9375 1.84375 11.625C1.6875 10.9687 1.71875 11.0625 1.25 10.5937C1.03125 10.3437 0.9375 9.99998 1.03125 9.68748C1.1875 9.03123 1.1875 9.12498 1.03125 8.49998C0.9375 8.15623 1.03125 7.81248 1.25 7.59373C1.71875 7.12498 1.6875 7.18748 1.84375 6.53123C1.9375 6.21873 2.1875 5.96873 2.5 5.87498C3.125 5.71873 3.03125 5.74998 3.5 5.28123C3.75 5.06248 4.09375 4.96873 4.40625 5.03123C5.03125 5.21873 4.9375 5.21873 5.5625 5.03123C5.875 4.96873 6.21875 5.06248 6.46875 5.28123C6.9375 5.74998 6.84375 5.71873 7.46875 5.87498C7.78125 5.96873 8.03125 6.21873 8.125 6.53123C8.28125 7.18748 8.25 7.12498 8.71875 7.59373C8.9375 7.81248 9.03125 8.15623 8.96875 8.49998C8.78125 9.12498 8.78125 9.03123 8.96875 9.68748C9.03125 9.99998 8.9375 10.3437 8.71875 10.5937ZM5 11C6.09375 11 6.96875 10.125 6.96875 8.99998C6.96875 7.90623 6.09375 6.99998 5 6.99998C3.875 6.99998 3 7.90623 3 8.99998C3 10.125 3.875 11 5 11ZM16.4062 2.93748C16.7812 3.31248 17 3.81248 16.9688 4.34373V14C16.9688 15.125 16.0625 16 14.9688 16H7.96875L8 14.5H14.9688C15.2188 14.5 15.4688 14.2812 15.4688 14V4.99998H13C12.4375 4.99998 12 4.56248 12 3.99998V1.53123H7C6.71875 1.53123 6.5 1.74998 6.5 2.03123L6.46875 4.15623C5.65625 3.84373 4.96875 4.15623 4.96875 4.15623V1.99998C4.96875 0.906235 5.84375 -1.52588e-05 6.96875 -1.52588e-05H12.6562C13.1875 -1.52588e-05 13.6875 0.218735 14.0625 0.593735L16.4062 2.93748Z" />
                                    </svg>
                                </div>
                            </div>
                            <div>
                                <p className="font-700">Get certificate of recognition</p>
                                <p className="text-12 text-darwin-neutral-700 mb-6">
                                    For your effort towards the national cause of digitising
                                    healthcare in India.
                                </p>
                                <a
                                    className="px-8 py-4 text-12 text-white bg-darwin-accent-bright-blue-800 rounded-4 hover:text-white"
                                    href="/images/abdm4.png"
                                    target="_blank"
                                    onClick={() => track('VIEW_SAMPLE_CERTIFICATE')}
                                >
                                    View sample
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="flex items-center justify-center space-x-24 py-10">
                    <p className="font-700 uppercase text-darwin-neutral-600">Approved by</p>
                    <img src="/images/abdm3.png" alt="abdm3" className="w-68 h-36" />
                </div>

                {showButtons && (
                    <div className="flex flex-col items-center">
                        <button
                            className="px-16 py-12 border border-darwin-accent-bright-blue-800 bg-darwin-accent-bright-blue-800 font-700 rounded-8 text-white cursor-pointer"
                            onClick={this.registerNow}
                        >
                            REGISTER NOW
                        </button>

                        <div className="flex justify-center space-x-24 text-darwin-accent-bright-blue-800 mt-8">
                            <Button onClick={this.knowMore} type="link">
                                Know more about ABDM
                            </Button>
                            <Button onClick={this.ekaABDM} type="link">
                                Eka ABDM Certificate
                            </Button>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export const ABDM = connect(null, (dispatch: ThunkDispatch<GlobalState, null, Actions>) => ({
    dispatch,
}))(ABDMComp);

export const ABDMBanner: React.FC = () => {
    const dispatch = useDispatch();
    const closeMe = (): void => {
        dispatch(hideDialog('abdm-banner'));
    };

    return (
        <ModalDialog>
            <Hotkeys keyName="esc" onKeyDown={closeMe}>
                <motion.div
                    initial={{ opacity: 0 }}
                    exit={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    style={{ zIndex: 200 }}
                    transition={{ duration: 0.2, ease: 'linear' }}
                    className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 font-lato"
                >
                    <div className="modal-overlay" onClick={closeMe}></div>
                    <div className="modal-content flex flex-col overflow-scroll hide-scrollbar">
                        <ABDM showButtons closeMe={closeMe} />
                    </div>
                </motion.div>
            </Hotkeys>
        </ModalDialog>
    );
};
